import useMenuTitle from "../hooks/useMenuTitle";
import AssetOperation from "../modules/assetOperation/AssetOperation";

function AssetOperationData() {
  useMenuTitle("Asset Operation Data");
  return <AssetOperation />;
}

export default AssetOperationData;
